import { tradingSummary } from '@/utils/tradingSummary';
import CountUp from '@/components/base/CountUp';
import Reveal from '@/components/base/Reveal';

const metrics = [
  { value: tradingSummary.winRateValue, decimals: 1, suffix: '%', label: 'Win Rate' },
  { value: tradingSummary.lossRateValue, decimals: 1, suffix: '%', label: 'Loss Rate' },
  { value: tradingSummary.longTrades, decimals: 0, suffix: '', label: 'Long Trades' },
  { value: tradingSummary.shortTrades, decimals: 0, suffix: '', label: 'Short Trades' },
];

function NumbersDashboard() {
  return (
    <section id="numbers" className="w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[34px] leading-[1.08] sm:text-[44px] lg:text-[50px]">
            The Numbers Behind the System
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-8 lg:gap-14 items-center">
          <Reveal>
            <div className="rounded-lg border border-background-300 bg-background-100 px-8 py-10 text-center">
              <p className="font-data text-[76px] md:text-[96px] font-semibold text-primary-600 leading-none">
                <CountUp value={tradingSummary.totalTrades} />
              </p>
              <p className="mt-3 text-[12px] font-data tracking-[0.22em] text-foreground-500">
                RECORDED TRADES
              </p>
              <p className="mt-5 text-[12px] text-foreground-500">
                {tradingSummary.period}
              </p>
            </div>
          </Reveal>

          <div className="grid grid-cols-2 gap-4 md:gap-5">
            {metrics.map((m, idx) => (
              <Reveal key={m.label} delay={idx * 110}>
                <div className="rounded-lg border border-background-300 bg-background-50 px-5 md:px-6 py-6 h-full hover:border-primary-300 transition-colors duration-300 cursor-default">
                  <p className="font-data text-[30px] md:text-[38px] font-semibold text-foreground-950 leading-none">
                    <CountUp value={m.value} decimals={m.decimals} suffix={m.suffix} />
                  </p>
                  <p className="mt-2.5 text-[12px] text-foreground-500">{m.label}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NumbersDashboard;